<template>
  <div class="needsValidation page-container">
    <div class="page-title">
      Payment Links
    </div>
    <div class="filter-container">
      <div class="custom-breadcrumbs">
        <i class="el-icon-arrow-left icon-back" @click="onClickBackBtn" />
        <span>{{ status === statusObj['Payment_Needs_Validation']? 'Creation': 'Submission' }}  Details</span>
      </div>

      <div class="btn-container">
        <el-button
          v-if="status === statusObj['Payment_Needs_Validation']"
          class="mb-10"
          type="danger"
          size="small"
          icon="el-icon-delete"
          :disabled="submiting"
          @click="onClickDeleteBtn"
        >{{ $t('components.delete') }}</el-button>

        <el-button
          v-if="status === statusObj['Payment_Approved']"
          class="mb-10"
          type="info"
          size="small"
          icon="el-icon-s-promotion"
          :disabled="submiting"
          @click="onClickEmailBtn"
        >Email</el-button>
      </div>

      <!-- <UploadExcelFile
        :merchant-id="merchantId"
        class="mt5 "
        :limit-num="1"
        @templateFileSuccess="templateFileSuccess"
      /> -->
    </div>
    <div class="tableContainer">
      <!-- 列表 -->
      <el-table
        v-loading="listLoading"
        :data="tableData"
        stripe
        fit
        highlight-current-row
        style="width: 100%"
        class="tableContainer"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
        />

        <el-table-column :label="$t('customerService.payment_method')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.payment_type }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.payment_channel')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.channel_code }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('customerService.reference')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.reference_batch_no }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('components.amount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.amount | toThousandFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('customerService.customer_name')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.customer_name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="status !== statusObj['Payment_Approved']"
          :label="$t('customerService.validation')"
          align="center"
          min-width="100"
        >
          <template slot-scope="scope">

            <el-tooltip v-if="scope.row.unvalidated_fields && scope.row.unvalidated_fields.length >0" placement="top">
              <div slot="content">
                <span>{{ scope.row.unvalidated_fields.join(',') }}</span> <br>
              </div>
              <el-tag type="danger" class="tag-custom">{{ scope.row.unvalidated_fields.join(',') }}</el-tag>
            </el-tooltip>

            <el-tag v-else type="success" class="tag-custom">Passed</el-tag>
          </template>
        </el-table-column>

        <el-table-column v-if="status !== statusObj['Payment_Approved']" :label="$t('components.email')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.email }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="status !== statusObj['Payment_Approved']" :label="$t('customerService.email_content')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.email_description }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="status !== statusObj['Payment_Approved']" :label="$t('data.remark')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.remark }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="status === statusObj['Payment_Approved']" :label="$t('components.status')" align="center" min-width="150">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.transaction_status" :type="getPOTransactionStatusType(scope.row.transaction_status)" class="modalBtn tag-custom"> {{ getPOTransactionStatusMap(scope.row.transaction_status) }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column v-if="status === statusObj['Payment_Approved']" :label="$t('components.link')" align="center" min-width="300">
          <template slot-scope="scope">
            <div class="link-container"> <span style="color:#3855F1; text-decoration: underline;">{{ scope.row.redirect_url }}</span>
              <el-button icon="el-icon-copy-document" :class="['btn-copy','copy-btn-'+scope.$index]" size="mini" type="primary" :data-clipboard-text="scope.row.redirect_url" @click="onClickCopyBtn('.copy-btn-'+scope.$index,'Link')">
                {{ $t('components.copy') }}</el-button></div>

          </template>
        </el-table-column>

        <el-table-column :label="$t('components.operation')" align="center" min-width="150">
          <template slot-scope="scope">
            <el-tooltip v-if="status === statusObj['Payment_Needs_Validation']" placement="top">
              <div slot="content">
                <span> {{ $t('components.edit') }}</span>
              </div>
              <svg-icon class-name="icon-function " icon-class="operation-edit" @click="onClickEditBtn(scope.row)" />
            </el-tooltip>

            <el-tooltip v-if="status === statusObj['Payment_Approved']" placement="top">
              <div slot="content">
                <span> {{ $t('components.detail') }}</span>
              </div>
              <svg-icon class-name="icon-function" icon-class="operation-detail" @click="onClickDetailBtn(scope.row)" />
            </el-tooltip>

          </template>
        </el-table-column>
      </el-table>
      <SinglePaymentEditModal ref="singleDisbursementEditModal" @getPaymentRefernceDetail="getPaymentRefernceDetail" />
    </div>
  </div>
</template>

<script>
import { fetchPaymentRefernceDetail, fetchPaymentRefernceDetailWithTrans, deletePaymentDetailData, sendPaymentEmail } from '@/api/online-transaction/online-transaction'
import { payTransactionStatusMap } from '@/utils/maps'
import { filterEmptyAttr } from '@/utils/common'
import SinglePaymentEditModal from './components/Modal/SinglePaymentEditModal.vue'
import Clipboard from 'clipboard'
export default {
  name: 'Detail_Disbursement',
  components: {
    SinglePaymentEditModal
  },
  data() {
    this.statusObj = {
      'Payment_Needs_Validation': 0,
      'Payment_Approved': 1
    }
    return {
      status: null,
      tableData: [],
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 15,
        total: 0
      },
      downloading: false,
      submiting: false,
      multipleSelection: []
    }
  },
  computed: {
    getPOTransactionStatusType() {
      return function(value) {
        return payTransactionStatusMap(value).type
      }
    },
    getPOTransactionStatusMap() {
      return function(value) {
        return payTransactionStatusMap(value).label
      }
    }
  },
  created() {
    const { status } = this.$route.params
    this.status = Number(status)
    this.getPaymentRefernceDetail()
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    getPaymentRefernceDetail() {
      this.listLoading = true
      const { id } = this.$route.params
      const params = {
        reference_batch_no: id
      }
      let event = fetchPaymentRefernceDetail
      if (this.status === this.statusObj['Payment_Approved']) {
        event = fetchPaymentRefernceDetailWithTrans
      }
      event(params).then(res => {
        if (res.code === 10000) {
          this.tableData = res.data || []
        }
      }).finally(() => {
        this.listLoading = false
      })
    },

    getParams(otherParams = {}) {
      const { payment_status, times = [] } = this.search
      let params = { start_date: times && times[0], end_date: times && times[1], payment_status, ...otherParams }
      params = filterEmptyAttr(params)
      return params
    },

    handleFilter(otherParams = {}) {
      const params = this.getParams(otherParams)
      this.getPaymentRefernceDetail(params)
    },
    onClickCopyBtn(selectClass, name) {
      const btnCopy = new Clipboard(selectClass)
      btnCopy.on('success', () => {
        this.$message.success(`Copy ${name} Successfully!`)
        btnCopy.destroy()
      })
      btnCopy.on('error', function(e) {
        btnCopy.destroy()
      })
    },
    onClickDeleteBtn() {
      if (!Array.isArray(this.multipleSelection) || this.multipleSelection.length <= 0) {
        this.$message.warning('Please select the left first and then delete!')
        return
      }
      const keyArr = this.multipleSelection.map(item => item.row_key)
      deletePaymentDetailData({ delete_key_list: keyArr }).then(res => {
        if (res.code === 10000) {
          this.$message.success('Delete Successfully')
          this.getPaymentRefernceDetail()
        }
      })
    },
    onClickEmailBtn() {
      if (!Array.isArray(this.multipleSelection) || this.multipleSelection.length <= 0) {
        this.$message.warning('Please select the left before sending!')
        return
      }
      this.submiting = true
      const keyArr = this.multipleSelection.map(item => item.row_key)
      sendPaymentEmail({ row_key_list: keyArr }).then(res => {
        if (res.code === 10000) {
          this.$message.success('Send Successfully')
          this.getPaymentRefernceDetail()
        }
      }).finally(() => {
        this.submiting = false
      })
    },

    onClickPaginator() {

      this.handleFilter(this.listQuery)
    },
    onClickEditBtn(row) {
      this.$refs.singleDisbursementEditModal.changModalStatus({
        status: true,
        value: row
      })
    },
    onClickDetailBtn(row) {
      const { id, status } = this.$route.params
      this.$router.push({ name: 'Online_Transaction_Detail_Payin_Link_Trans', query: { id, status, rId: row.row_key }})
    },
    onClickBackBtn() {
      this.$router.push({ name: 'Online_Transaction_Payment_Link', query: { status: this.status }})
    }
  }
}
</script>

<style lang="scss" scoped>
.needsValidation{
   .transTime{
    display: inline-block;
    padding: 0 20px 10px 0;
    font-size: 14px;
    font-weight: 500;  font-family: 'Inter-Medium';
    color: #606266;
  }
  .btn-container{
    display: flex;
    justify-content: flex-end;
  }
  .search-frame {
    width: 160px;
    margin-right: 5px;
  }
  .search-btn {
    margin-right: 10px;
  }
  .picker{
    margin-right: 5px;
  }
  .status{
    margin-right: 10px;
  }
  .download-btn{
    margin: 0;
  }
 .mb-10{
    margin-bottom: 10px;
  }
  .link-container{
    display: inline-flex;
    align-items: center;
  }
  .btn-copy{
    margin-left: 10px;
  }
}

</style>
